import { markRaw } from 'vue'
import { ApprovalTrigger } from '@/gql/graphql'
import ApprovalHireDisplayForTable from '@/components/Workflows/Approvals/Triggers/Hire/ApprovalHireDisplayForTable.vue'
import ApprovalClassificationDisplayForTable from '@/components/Workflows/Approvals/Triggers/Classification/ApprovalClassificationDisplayForTable.vue'

export function triggerToTableDisplay(trigger: ApprovalTrigger) {
  switch (trigger) {
    case ApprovalTrigger.HireCreated:
    case ApprovalTrigger.HireChanged:
      return markRaw(ApprovalHireDisplayForTable)
    case ApprovalTrigger.ClassificationCreated:
      return markRaw(ApprovalClassificationDisplayForTable)
    default:
      return null
  }
}
